import React, { useRef, useEffect } from "react";

const RateCanvas = ({ rates }) => {
  const canvasRef = useRef(null);
  let textWidth = 0;
  let textHeight = 0;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Очистка холста
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Установка фона
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Стиль текста

    ctx.fillStyle = "#000";

    ctx.font = "10px Arial";
    const formattedVoteKP = rates.rate.voteKP
      ? rates.rate.voteKP.toLocaleString("ru-RU").replace(/,/g, " ")
      : "--";
    ctx.fillText(`${formattedVoteKP}`, 5, 10);
    ctx.font = "14px Arial";
    textWidth = ctx.measureText(rates.rate.rateKP).width;
    textHeight = parseInt(ctx.font.match(/\d+/)[0], 10);
    const rateKPText = rates.rate.rateKP
      ? Number(rates.rate.rateKP).toFixed(1)
      : "--";
    ctx.fillText(rateKPText, 5, canvas.height - 2);

    ctx.font = "14px Arial";
    const rateMpaaText = rates.options.rate_mpaa_S
      ? rates.options.rate_mpaa_S
      : "--";

    textWidth = ctx.measureText(rateMpaaText).width;

    ctx.fillText(rateMpaaText, canvas.width / 2 - textWidth / 2, 15);

    ctx.font = "14px Arial";
    // Проверяем наличие значения и добавляем "+" только если значение есть
    const ratePopulText = rates.options.ratepopul_S
      ? `${rates.options.ratepopul_S}+`
      : "--";

    textWidth = ctx.measureText(ratePopulText).width;

    // Рисуем текст, центрируя его
    ctx.fillText(
      ratePopulText,
      canvas.width / 2 - textWidth / 2,
      canvas.height - 7
    );

    ctx.font = "10px Arial";
    const formattedVoteIMDB = rates.rate.voteIMDB
      ? rates.rate.voteIMDB.toLocaleString("ru-RU").replace(/,/g, " ")
      : "--";
    textWidth = ctx.measureText(formattedVoteIMDB).width;
    ctx.fillText(`${formattedVoteIMDB}`, canvas.width - textWidth - 5, 10);
      ctx.font = "14px Arial";
      const formattedRateIMDB = rates.rate.rateIMDB
          ? rates.rate.rateIMDB : "--";
    textWidth = ctx.measureText(formattedRateIMDB).width;
    textHeight = parseInt(ctx.font.match(/\d+/)[0], 10);
    ctx.fillText(
      formattedRateIMDB,
      canvas.width - textWidth - 5,
      canvas.height - 2
    );
  }, [rates]);

  return (
    <canvas
      ref={canvasRef}
      width={102}
      height={38}
      style={{ border: "1px solid #000" }}
    />
  );
};

export default RateCanvas;
